var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"opc-nav__back"},[_c('zm-button',{attrs:{"ghost":""},on:{"click":_vm.back}},[_c('i',{staticClass:"zm-icon-left"}),_vm._v(" "+_vm._s(_vm.backContent || _vm.$t('common.btn_back'))+" ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }